import { useState } from "react";
import Icon from "components/Icons/Icon";
import "../css/Website.scss";

const Faq = ({ title, description }) => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <div className={`faq ${isOpen && "active"}`}>
      <header onClick={() => setIsOpen(!isOpen)}>
        <h4>{title}</h4>
        <Icon name="arrowDown" />
      </header>
      {isOpen ? (
        <div className="description">
          <p>{description}</p>
        </div>
      ) : null}
    </div>
  );
};

export default Faq;
